import React, { useEffect, useState } from 'react'
import { useRefinementList } from 'react-instantsearch'
import CustomShowMore from '@bodeboca/algolia/components/filters/show-more'
import { useTranslation } from 'react-i18next'
import CommonUtils from '@bodeboca/utils'
import ApiService from '@bodeboca/api'

const CustomRefinementFilter = ({
  attribute, limit, showMore, showMoreLimit, popup, linkOnly = false, title, shortLimit = 3, searchable, searchablePlaceholder,
}) => {
  let {
    items, refine, searchForItems, toggleShowMore, isShowingMore,
  } = useRefinementList({
    showMoreLimit, attribute, limit, showMore,
  })
  const initialItems = shortLimit
  const minItemsForModal = limit
  const { t } = useTranslation()
  const [open, setOpen] = useState<boolean>(false)
  const [query, setQuery] = useState<string>('')
  const [numShownElements, setNumShownElements] = useState(initialItems)
  const [isListOpen, setIsListOpen] = useState(false)
  const numRefinements = items.filter((item) => {
    return item.isRefined
  }).length
  const isModalVisible = items.length > 20 && isShowingMore && popup && CommonUtils.getBreakpoint() > CommonUtils.BREAKPOINT_SMALL
  const sortedItems = () => {
    let returnItems = []
    for (let i = 0; i < items.length; i++) {

      let data = ApiService.getItemFromId(attribute, items[i].label)
      let currentItem = {...items[i]}
      if (data !== undefined) {
        currentItem['data'] = data
        currentItem['label'] = data['label']
      }
      // Do not show elements which should have translation but don't.
      if(data.hide === false ) {
        returnItems.push(currentItem)
      }
    }

    if (isShowingMore && CommonUtils.getBreakpoint() > CommonUtils.BREAKPOINT_SMALL) {
      returnItems = returnItems.sort((a, b) => a.label.localeCompare(b.label))
    }
    else {
      returnItems = returnItems.slice(0, numShownElements + numRefinements)
    }

    return returnItems
  }
  const toggleNumElements = () => {
    if (!isListOpen) {
      setNumShownElements(limit)
    }
    else {
      setNumShownElements(shortLimit)
    }
    setIsListOpen(!isListOpen)
  }

  function customRefine(value) {
    if (isShowingMore) {
      toggleShowMore()
    }
    refine(value)
    setOpen(false)
    setNumShownElements(shortLimit)
    setIsListOpen(false)
    CommonUtils.onStateChange()
    CommonUtils.hideFilters()
  }

  function customSearchForItems(query) {
    // TODO: Refactor to filter locally (avoids extra Algolia queries).
    setQuery(query)
    searchForItems(query)
  }

  // Block body on modal
  useEffect(() => {
    CommonUtils.setBodyBlocked(isModalVisible)

  }, [isModalVisible])

  return (<>
    {isShowingMore && popup && <div
      className={'hover-filter-background'}
      onClick={() => {
        toggleShowMore()
      }}/>}
    {((items.length > 1) || (searchable && query !== '')) && <div
      className={'bb-filter-options ' + (open ? 'filter-options-mobile-open' : '') + (isModalVisible ? 'bb-filter-options-popup' : '')}>

      <div
        className="ui-button ui-corner-all ui-widget ui-button-icon-only ui-dialog-titlebar-close icon bbicon-icono-model-close"
        title="Close"
        onClick={() => toggleShowMore()}>
      </div>
      <h4
        className="bb-filter-processed"
        onClick={() => setOpen(!open)}>
        {t(title)}
      </h4>
      <div className={'ais-Menu item-list searchable-menu'}>
        {searchable && <input
          autoCapitalize="off"
          autoComplete="off"
          autoCorrect="off"
          maxLength={512}
          placeholder={t(searchablePlaceholder)}
          spellCheck={false}
          type="search"
          onChange={(event) => customSearchForItems(event.currentTarget.value)}/>}
        <ul className="ais-Menu-list dropdown-menu">
          {sortedItems().map((item) => (<>
            <li
              className="ais-Menu-item dropdown-menu-item"
              key={item.label}>
              {linkOnly && item['data'] !== undefined && <a
                className="ais-Menu-link"
                href={item['data']['path']}
                style={{ fontWeight: item.isRefined ? 'bold' : 'normal' }}>
                <span
                  className="ais-Menu-label">{item.label}
                </span>
                <span
                  className="ais-Menu-count">{item.count}
                </span>
              </a>}
              {!linkOnly && <a
                className="ais-Menu-link"
                style={{ fontWeight: item.isRefined ? 'bold' : 'normal' }}
                onClick={(event) => {
                  customRefine(item.value)
                }}>
                <input
                  checked={item.isRefined}
                  type={'checkbox'}
                  onChange={() => {
                    //Do nothing
                  }}/>
                <span
                  className="ais-Menu-label">{item.label}
                </span>
                <span
                  className="ais-Menu-count">{item.count}
                </span>
              </a>}
            </li>
          </>))}
        </ul>
        {isListOpen && popup && items.length >= minItemsForModal && <div
          className="show-more use-ajax"
          onClick={() => {
            toggleShowMore()
          }}>{ t('Show all') + ' →'}
        </div>}
        {items.length > 3 && <CustomShowMore
          isShowingMore={isListOpen}
          popup={popup}
          showMore={showMore}
          toggleShowMore={toggleNumElements}/>}
      </div>
    </div>}
  </>)
}

export default CustomRefinementFilter
